/** Small math helpers used across rendering and gameplay. */
export const TAU = Math.PI * 2

export const clamp = (v: number, min: number, max: number): number =>
  v < min ? min : v > max ? max : v

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t

/** Frame-rate independent exponential approach of `a` toward `b`. */
export const damp = (a: number, b: number, lambda: number, dt: number): number =>
  lerp(a, b, 1 - Math.exp(-lambda * dt))

export const smoothstep = (e0: number, e1: number, x: number): number => {
  const t = clamp((x - e0) / (e1 - e0), 0, 1)
  return t * t * (3 - 2 * t)
}

export const randRange = (min: number, max: number): number => min + Math.random() * (max - min)

export const randInt = (min: number, max: number): number => Math.floor(randRange(min, max + 1))

export const pick = <T>(arr: readonly T[]): T => arr[Math.floor(Math.random() * arr.length)]
